// src/ui/AppErrorFallback.tsx
import React, { useState } from 'react';
import { Result, Button, Space, Typography, Collapse } from 'antd';

type Props = {
  error: Error | null;
  reset: () => void;
};

function clearSavedTableViews() {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (k.startsWith('table.')) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}

const AppErrorFallback: React.FC<Props> = ({ error, reset }) => {
  const [cleared, setCleared] = useState(false);

  return (
    <Result
      status="error"
      title="Упс! Приложение столкнулось с ошибкой"
      subTitle="Вы можете попробовать восстановиться, не перезагружая страницу."
      extra={
        <Space wrap>
          <Button type="primary" onClick={reset}>Попробовать снова</Button>
          <Button onClick={() => window.location.reload()}>Обновить страницу</Button>
          <Button
            danger
            onClick={() => {
              clearSavedTableViews();
              setCleared(true);
            }}
          >
            Сбросить сохранённые виды таблиц
          </Button>
        </Space>
      }
    >
      {cleared && (
        <Typography.Paragraph type="success" style={{ marginTop: 8 }}>
          Виды таблиц сброшены (ключи localStorage с префиксом <code>table.</code> удалены).
        </Typography.Paragraph>
      )}

      {error && (
        <Collapse style={{ marginTop: 16 }}>
          <Collapse.Panel header="Технические детали (для разработчика)" key="err">
            <Typography.Paragraph>
              <b>Сообщение:</b> {error.message}
            </Typography.Paragraph>
            <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>
              {String((error as any).stack || '')}
            </Typography.Paragraph>
          </Collapse.Panel>
        </Collapse>
      )}
    </Result>
  );
};

export default AppErrorFallback;
